export enum PaymentMethod {
  WALLET = 'wallet',
  SMARTPAY = 'smartpay',
  VOUCHERS = 'vouchers',
  CARD = 'card',
  BOOST = 'wallet',
  TNG = 'wallet',
  ONLINEBANKING = 'online_banking',
  GIFT_CARD = 'gift_card',
}

export enum PaymentSubmethod {
  WALLET_SETEL = 'wallet_setel',
  CARD_VISA = 'card_visa',
  CARD_MASTERCARD = 'card_mastercard',
  CARD_AMEX = 'card_amex',
  SMARTPAY = 'smartpay',
  VOUCHERS = 'vouchers',
  CASH = 'cash',
  BOOST = 'wallet_boost',
  TNG = 'wallet_tng',
  GIFT_CARD = 'gift_card',
}

export enum DigitalWallet {
  WALLET_SETEL = 'wallet_setel',
  BOOST = 'wallet_boost',
  GRAB_PAY = 'wallet_grab',
  TNG = 'wallet_tng',
  SHOPEE_PAY = 'wallet_shopeepay',
}

export enum DigitalWalletTitle {
  WALLET_SETEL = 'Setel Wallet',
  BOOST = 'Boost eWallet',
  GRAB_PAY = 'GrabPay',
  TNG = 'Touch ‘n Go eWallet',
  SHOPEE_PAY = 'ShopeePay',
}

export const DigitalWalletMap: Map<DigitalWallet, DigitalWalletTitle> = new Map<DigitalWallet, DigitalWalletTitle>([
  [DigitalWallet.WALLET_SETEL, DigitalWalletTitle.WALLET_SETEL],
  [DigitalWallet.BOOST, DigitalWalletTitle.BOOST],
  [DigitalWallet.GRAB_PAY, DigitalWalletTitle.GRAB_PAY],
  [DigitalWallet.TNG, DigitalWalletTitle.TNG],
  [DigitalWallet.SHOPEE_PAY, DigitalWalletTitle.SHOPEE_PAY],
])

export enum TransactionType {
  topup = 'TOPUP',
  refund = 'REFUND',
  purchase = 'PURCHASE',
  authorize = 'AUTHORIZE',
  capture = 'CAPTURE',
  cancel = 'CANCEL',
  topup_refund = 'TOPUP_REFUND',
}

export enum TransactionSubType {
  topupBankAccount = 'TOPUP_BANK_ACCOUNT',
  topupCreditCard = 'TOPUP_CREDIT_CARD',
  topupRefundCreditCard = 'TOPUP_REFUND_CREDIT_CARD',
  topupRefundBankAccount = 'TOPUP_REFUND_BANK_ACCOUNT',
  topupExternal = 'TOPUP_EXTERNAL',
  refundExternal = 'REFUND_EXTERNAL',
  redeemLoyaltyPoints = 'REDEEM_LOYALTY_POINTS',
  rewards = 'REWARDS',
  autoTopup = 'AUTO_TOPUP',
}

export enum TransactionWalletSubType {
  TOPUP_BANK_ACCOUNT = 'TOPUP_BANK_ACCOUNT',
  TOPUP_CREDIT_CARD = 'TOPUP_CREDIT_CARD',
  TOPUP_REFUND_BANK_ACCOUNT = 'TOPUP_REFUND_BANK_ACCOUNT',
  TOPUP_REFUND_CREDIT_CARD = 'TOPUP_REFUND_CREDIT_CARD',
  TOPUP_DIGITAL_WALLET = 'TOPUP_DIGITAL_WALLET',
  TOPUP_REFUND_DIGITAL_WALLET = 'TOPUP_REFUND_DIGITAL_WALLET',
}

export enum TransactionStatus {
  success = 'success',
  pending = 'pending',
  error = 'error',
  failed = 'failed',
  cancelled = 'cancelled',
  reversed = 'reversed',
  incoming = 'incoming',
}
